import { actions } from './action'

const initialState = {
  batchData: {
    batchList: [],
    totalCount: 0,
  },
  allBatch: [],
  pagination: {
    skip: 0,
    limit: 10,
  },
}
const batchState = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_BATCH:
      return {
        ...state,
        batchData: {
          batchList: action.payload.batchList,
          totalCount: action.payload.totalCount,
        },
      }
    case actions.GET_ALL_BATCHES:
      return {
        ...state,
        allBatch: action.payload.batchList,
      }

    case actions.HANDLE_PAGINATION:
      return {
        ...state,
        pagination: action.payload,
      }
    case actions.UPDATE_BATCH:
      return {
        ...state,
        batchData: {
          ...state.batchData,
          batchList: state.batchData.batchList.map((batch) =>
            batch.id === action.payload.id ? action.payload : batch,
          ),
        },
      }
    default:
      return state
  }
}
export default batchState
